import { v4 as uuidv4 } from 'uuid'
import * as moment from 'moment'
import { IJobSlot, IJobBulkPlan } from 'static/interfaces'
import { JOB_SKILL_LEVEL_MIN, JOB_SKILL_LEVEL_MAX } from 'static/constants'

export type JobStatus = 'open' | 'upcoming' | 'ended'

// サーバ(ToursWeekly::JobSummarySerializer)と同等の判定
export const getJobStatus = (job: {
  publish_start_at: string | null
  publish_end_at: string | null
}): JobStatus => {
  const now = moment()
  if (now.isAfter(moment(job.publish_end_at))) {
    return 'ended'
  }
  return moment(job.publish_start_at).isSameOrBefore(now) ? 'open' : 'upcoming'
}

// 募集スロットのスキルマーク既定値(△以上)。SKILL_LEVELS の '3' が △
export const JOB_SLOT_DEFAULT_SKILL_MIN_LEVEL = 3

export const defaultJobSlot = (): IJobSlot => {
  return {
    id: null,
    skill_ids: [],
    tour_skill_id: null,
    tour_skill_min_level: JOB_SLOT_DEFAULT_SKILL_MIN_LEVEL,
    tour_skill_max_level: JOB_SKILL_LEVEL_MAX,
    direct_max_limit: 0,
    direct_count: 0,
    selection_max_limit: 0,
    client_uid: uuidv4(),
  } as IJobSlot
}

export const skillCondition = (min: number, max: number) => {
  if (min == null || max == null) {
    return { level: JOB_SKILL_LEVEL_MIN, condition: 'exact' }
  }
  if (min === max) {
    return { level: min, condition: 'exact' }
  }
  if (min === JOB_SKILL_LEVEL_MIN) {
    return { level: max, condition: 'lte' }
  }
  if (max === JOB_SKILL_LEVEL_MAX) {
    return { level: min, condition: 'gte' }
  }

  return { level: JOB_SKILL_LEVEL_MIN, condition: 'exact' }
}

export const convertLevelToRange = (level: string, condition_type: string) => {
  switch (condition_type) {
    case 'gte':
      return {
        min_level: Number(level),
        max_level: JOB_SKILL_LEVEL_MAX,
      }

    case 'lte':
      return {
        min_level: JOB_SKILL_LEVEL_MIN,
        max_level: Number(level),
      }
    case 'exact':
      return {
        min_level: Number(level),
        max_level: Number(level),
      }
    default:
      return { min_level: 0, max_level: 999 }
  }
}

export const weekDaysChecked = (jobBulkPlan: IJobBulkPlan) => {
  const checked = []
  if (jobBulkPlan.weekday_0) {
    checked.push(0)
  }
  if (jobBulkPlan.weekday_1) {
    checked.push(1)
  }
  if (jobBulkPlan.weekday_2) {
    checked.push(2)
  }
  if (jobBulkPlan.weekday_3) {
    checked.push(3)
  }
  if (jobBulkPlan.weekday_4) {
    checked.push(4)
  }
  if (jobBulkPlan.weekday_5) {
    checked.push(5)
  }
  if (jobBulkPlan.weekday_6) {
    checked.push(6)
  }
  return checked
}
